!function($, window, document) {
    const $win = $(window), $doc = $(document);
    $(document.body);
    let resizeTimer, lastScrollTop = 0;
    function window_width() {
        return $win.width();
    }
    function is_mobile() {
        return window_width() <= 767;
    }
    $.event.special.widthResize = {
        setup: function() {
            const $this = $(this);
            $this.data("currentWidth", $this.width()), $this.on("resize.widthResize", (function() {
                const newWidth = $this.width();
                newWidth !== $this.data("currentWidth") && $this.data("currentWidth", newWidth).trigger("widthResize");
            }));
        },
        teardown: function() {
            $(this).off("resize.widthResize");
        }
    };
    const fixedHeader = () => {
        const $header = $(".header"), headerAppearPlace = $(".hero").length ? $win.outerHeight() : 0;
        let scrollTop = $(this).scrollTop();
        scrollTop > lastScrollTop && scrollTop > $($header).outerHeight() ? ($header.addClass("scroll-down"), 
        $header.removeClass("scroll-up")) : ($header.removeClass("scroll-down"), $header.addClass("scroll-up")), 
        $header.toggleClass("is-dark", $win.scrollTop() >= headerAppearPlace / 2), $header.toggleClass("has-transition", $win.scrollTop() >= headerAppearPlace / 1.5), 
        $header.toggleClass("is-visible", $win.scrollTop() >= headerAppearPlace), lastScrollTop = scrollTop;
    }, togglePlayPauseInSlides = slides => {
        slides.each((function() {
            const $slide = $(this), $media = $slide.find(".media");
            if ($media.find(".plyr").length && $media[0].plyr && ($media[0].plyr.pause(), $slide.hasClass("slick-active"))) {
                const $currentMedia = $slide.find(".media");
                !0 === $currentMedia.data("autoplay") && $currentMedia[0].plyr.play();
            }
        }));
    }, initSlider = (slider, options) => {
        $(slider).each((function() {
            if (0 == $(this).find(".slick-initialized").length) {
                const $currentSlider = $(this), $sliderInitilizer = $currentSlider.find(".slider__slides");
                $sliderInitilizer.on("init", (function() {
                    togglePlayPauseInSlides($currentSlider.find(".slick-slide"));
                })), $sliderInitilizer.on("afterChange", (function() {
                    togglePlayPauseInSlides($currentSlider.find(".slick-slide"));
                })), $sliderInitilizer.slick({
                    slidesToShow: 1,
                    draggable: !1,
                    slidesToScroll: 1,
                    arrows: !0,
                    autoplay: !1,
                    dots: !1,
                    responsive: [ {
                        breakpoint: 1080,
                        settings: {
                            swipe: !0,
                            draggable: !0,
                            fade: !1
                        }
                    } ],
                    ...options
                });
            }
        }));
    }, initMobileSliders = (slider, options) => {
        const $sliders = slider;
        $sliders.length && $($sliders).each((function() {
            if (is_mobile() && 0 == $(this).find(".slick-initialized").length) {
                const $currentSlider = $(this), $customArrows = ($currentSlider.find(".slider__slides"), 
                $currentSlider.closest("section").find(".js-slider-arrows"));
                $(this).slick({
                    slidesToScroll: 1,
                    swipe: !0,
                    draggable: !0,
                    infinite: !1,
                    arrows: !0,
                    mobileFirst: !0,
                    appendArrows: $customArrows || null,
                    responsive: [ {
                        breakpoint: 767,
                        settings: "unslick"
                    } ],
                    ...options
                }), $currentSlider.find(".slick-slide").length > $currentSlider.slick("slickGetOption", "slidesToShow") && $currentSlider.closest("section").addClass("has-slider");
            }
        }));
    }, setHeaderHeightAsCssVariable = () => {
        $("body").css("--header-h", `${$(".header").outerHeight()}px`);
    };
    function setInfoTextWidthToArtcle() {
        $(".article").each((function() {
            const $article = $(this);
            if (!$article.find(".article__date").length) return;
            const $articleDate = $article.find(".article__date");
            $article.css("--date-width", `${$articleDate.outerWidth()}px`);
        }));
    }
    function setInfoTextWidthToCard() {
        $(".card-search").each((function() {
            const $article = $(this);
            if (!$article.find(".card__date").length) return;
            const $articleDate = $article.find(".card__date");
            $article.css("--date-width", `${$articleDate.outerWidth()}px`);
        }));
    }
    var options;
    $(".js-toggle-menu").on("click", (function(e) {
        e.preventDefault(), $(this).toggleClass("is-active"), $("body").toggleClass("nav-open not-scrollable");
    })), $doc.on("click", (function(e) {
        $win.outerWidth() > 768 && $(e.target).hasClass("popup-nav") && ($(".js-toggle-menu").removeClass("is-active"), 
        $("body").removeClass("nav-open not-scrollable"));
    })), $doc.on("click", (function(e) {
        $win.outerWidth() > 768 && $(e.target).hasClass("popup-search") && $("body").removeClass("search-open");
    })), $(".menu-item-has-children > a").on("click", (function(e) {
        (function isTouchDevice() {
            return "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        })() && !$(this).parents(".menu-item-has-children").hasClass("disable-touch") && (e.preventDefault(), 
        $(this).parent().toggleClass("is-active").siblings().removeClass("is-active"), is_mobile() && $(this).parent().find(".dropdown").slideToggle().closest("li").siblings().find(".dropdown").slideUp("is-active"));
    })), $(".js-toggle-search").on("click", (function(e) {
        e.preventDefault(), $("body").toggleClass("search-open");
    })), $(".js-read-more").on("click", (function(e) {
        e.preventDefault();
        const $readMoreBtn = $(this), readMoreText = $readMoreBtn.hasClass("is-active") ? "Read bio →" : "Hide ↑";
        $readMoreBtn.toggleClass("is-active").text(readMoreText).parent().find(".hidden").slideToggle();
    })), $(".js-more").on("click", (function(e) {
        e.preventDefault();
        const $readMoreBtn = $(this), readMoreText = $readMoreBtn.hasClass("is-active") ? "+ Read more" : "- Read less";
        $readMoreBtn.toggleClass("is-active").text(readMoreText).parent().find(".hidden").slideToggle();
    })), $(".js-toggle-popup").on("click", (function(e) {
        e.preventDefault();
        const $target = $($(this).attr("data-id"));
        if (!$target.length) return;
        const slideIndex = parseInt($(this).attr("data-slide-index"));
        initSlider(".js-slider-popup", {
            slidesToShow: 1,
            infinite: !1,
            arrows: !0,
            swipe: !0,
            draggable: !0,
            dots: !0,
            responsive: [ {
                breakpoint: 767,
                settings: {
                    arrows: !1,
                    variableWidth: !1
                }
            } ]
        }), slideIndex >= 0 && $(".js-slider-popup .slider__slides").slick("slickGoTo", slideIndex, !0), 
        $("body").toggleClass("not-scrollable"), $target.toggleClass("is-active");
    })), initSlider(".js-slider-hero", {
        slidesToShow: 1,
        infinite: !0,
        arrows: !1,
        dots: !0,
        row: 0,
        autoplay: !0,
        autoplaySpeed: 4e3,
        pauseOnHover: !1,
        responsive: [ {
            breakpoint: 767,
            settings: {
                dots: !1,
                autoplay: !0,
                pauseOnHover: !1
            }
        } ]
    }), initSlider(".js-slider-media", {
        slidesToShow: 1,
        infinite: !0,
        arrows: !0,
        adaptiveHeight: !0,
        dots: !0,
        prevArrow: "<button type='button' class='slick-prev'>←</button>",
        nextArrow: "<button type='button' class='slick-next'>→</button>",
        responsive: [ {
            breakpoint: 768,
            settings: {
                arrows: !1,
                dots: !1
            }
        } ]
    }), $(".js-player").each((function() {
        if (!this) return;
        const $currentMedia = $(this).closest(".media"), mediaAutoplay = "click" !== $currentMedia.data("autoplay") && !1 !== $currentMedia.data("autoplay") && "hover" !== $currentMedia.data("autoplay"), clickToPlay = !0 === $currentMedia.data("click-to-play"), player = new Plyr(this, {
            volume: 0,
            autoplay: !1,
            clickToPlay: clickToPlay,
            controls: [],
            muted: !0,
            loop: {
                active: !0
            },
            vimeo: {
                background: !0
            },
            ...options
        });
        let observer = new IntersectionObserver((entries => {
            entries.map((entry => {
                entry.isIntersecting && mediaAutoplay && player ? player.play() : player.pause();
            }));
        }), {
            rootMargin: "0px +200px",
            threshold: 0
        });
        $currentMedia[0].plyr = player, player.on("ready", (() => {
            (video => {
                const player = video[0].plyr;
                video.data("mute") ? (player.muted = !0, player.volume = 0, player.decreaseVolume(100)) : (player.muted = !1, 
                player.volume = 1, player.increaseVolume(100));
            })($currentMedia), player.pause(), observer.observe($currentMedia[0]);
        })), player.on("play", (() => {
            $currentMedia.addClass("is-played");
        })), player.on("pause", (() => {
            $currentMedia.removeClass("is-played").find(".js-play-btn").removeClass("is-played");
        }));
    })), fixedHeader(), $(".slick-dots").each((function() {
        const $dots = $(this);
        $dots.closest("section").css("--dots-w", `${$dots.outerWidth()}px`);
    })), setHeaderHeightAsCssVariable(), initMobileSliders(".js-slider-mobile", {
        slidesToShow: 1
    }), setInfoTextWidthToArtcle(), setInfoTextWidthToCard();
    const intersectionObserver = new IntersectionObserver((entries => {
        entries.forEach((entry => {
            entry.isIntersecting && $(entry.target).addClass("is-visible");
        }));
    }), {
        threshold: 0,
        rootMargin: "-80px 0px"
    });
    document.querySelectorAll("[data-slide-up]").forEach((el => {
        intersectionObserver.observe(el);
    })), $win.on("resize", (() => {
        setHeaderHeightAsCssVariable();
    })).on("scroll", (() => {
        fixedHeader();
    })), $win.on("widthResize", (function() {
        clearTimeout(resizeTimer), setInfoTextWidthToCard(), setInfoTextWidthToArtcle(), 
        resizeTimer = setTimeout((function() {
            initMobileSliders(".js-slider-mobile", {
                slidesToShow: 1
            });
        }), 250);
    })), $(".js-scroll-to").on("click", (function(e) {
        e.preventDefault();
        let target = $(this.getAttribute("href"));
        target.length && ($("html, body").animate({
            scrollTop: target.offset().top
        }, 800), $(".js-toggle-menu").trigger("click"));
    }));
    const observerOptions = {
        root: null,
        rootMargin: "0px",
        threshold: .1
    };
    let observer = null;
    function observeLastRow() {
        observer && (observer.disconnect(), observer = null);
        if ($(".articles .grid .grid__col.grid__col--1of3").length < 12) return;
        const target = function lastVisibleRowElement() {
            const gridItems = $(".articles .grid .grid__col.grid__col--1of3");
            if (0 === gridItems.length) return null;
            const index = 3 * Math.floor((gridItems.length - 1) / 3);
            return gridItems.eq(index).get(0);
        }();
        target && (observer = new IntersectionObserver((entries => {
            entries.forEach((entry => {
                entry.isIntersecting && ($(".js-load-more-projects").trigger("click"), observer.disconnect());
            }));
        }), observerOptions), observer.observe(target));
    }
    observeLastRow(), $doc.on("click", ".js-filter-projects", (function(e) {
        e.preventDefault();
        const sector = $(this).data("sector");
        $(this).parent("li").addClass("is-active").siblings().removeClass("is-active"), 
        $.ajax({
            url: window.location.origin + window.location.pathname,
            data: {
                sector: sector
            },
            beforeSend: function() {
                $(".articles .grid").fadeOut(), $(".js-load-more-projects").fadeOut();
            },
            success: function(response) {
                $(".articles .grid").html($(response).find(".articles .grid").html()), observer && (observer.disconnect(), 
                observer = null), $(".js-load-more-projects").length || $(response).find(".section-filters .section__actions").insertAfter(".articles"), 
                $(response).find(".articles .grid .grid__col.grid__col--1of3").length < 12 ? $(".js-load-more-projects").hide() : $(".js-load-more-projects").data("page", 2).show(), 
                setTimeout((() => {
                    observeLastRow();
                }), 100), $(".articles .grid").fadeIn(), $(".js-load-more-projects").fadeIn();
                const url = new URL(window.location);
                url.searchParams.set("sector", sector), window.history.pushState({}, "", url);
            }
        });
    })), $doc.on("click", ".js-load-more-projects", (function(e) {
        e.preventDefault();
        let page = $(this).data("page");
        const sector = new URLSearchParams(window.location.search).get("sector");
        $.ajax({
            url: "/wp-json/efr/v1/load_more_projects",
            data: {
                page: page,
                ...sector && {
                    sector: sector
                }
            },
            success: function(response) {
                $(".articles .grid").append(response.html), response.page ? ($(".js-load-more-projects").data("page", response.page), 
                observeLastRow()) : ($(".section__actions").hide(), observer && (observer.disconnect(), 
                observer = null));
            }
        });
    })), $(window).bind("popstate", (function() {
        window.location = location.href;
    })), $(".js-clear-sectors").on("click", (function(e) {
        e.preventDefault(), $(".filters li").removeClass("is-active"), $(".filters li:first-of-type").addClass("is-active"), 
        $.ajax({
            url: window.location.origin + window.location.pathname,
            success: function(response) {
                $(".articles .grid").html($(response).find(".articles .grid").html()), observer && (observer.disconnect(), 
                observer = null), $(".js-load-more-projects").data("page", 2), setTimeout((() => {
                    observeLastRow();
                }), 100);
                let url = new URL(window.location.origin + window.location.pathname);
                window.history.pushState({
                    path: url.href
                }, "", url.href);
            }
        });
    })), $(".js-filter-news").on("click", (function(e) {
        e.preventDefault(), $(this).parent("li").addClass("is-active"), $(this).parent("li").siblings().removeClass("is-active");
        let category = $(this).data("cat");
        $.ajax({
            url: window.location.href,
            data: {
                category: category
            },
            success: function(response) {
                $(".js-news-container").html($(response).find(".js-news-container").html()), $(response).find(".section__actions").length ? $(".js-load-more-news").data("page", 2) : $(".section__actions").hide();
                const url = new URL(window.location);
                url.searchParams.set("category", category), window.history.pushState({
                    path: url.href
                }, "", url.href);
            }
        });
    })), $doc.on("click", ".js-load-more-news", (function(e) {
        e.preventDefault();
        let page = $(this).data("page");
        $.ajax({
            url: "/wp-json/efr/v1/load_more_news",
            data: {
                page: page
            },
            success: function(response) {
                $(".articles--large-space .grid").append(response.html), "" !== response.page ? $(".js-load-more-news").data("page", response.page) : $(".section__actions").hide();
            }
        });
    })), $doc.on("submit", ".js-search", (function(e) {
        e.preventDefault();
        let $searchField = $(".search__field"), term = $searchField.val().trim().replace(/\s*\(\d+\)/g, "");
        term ? ($(".cards-search").fadeOut(200), $searchField.css("opacity", .5), $.ajax({
            url: "/wp-json/efr/v1/search",
            data: {
                term: term
            },
            success: function(response) {
                $(".cards-search").html(response.html).fadeIn(200), $searchField.css("opacity", 1), 
                $searchField.val(term + " (" + response.count + ")"), setInfoTextWidthToCard();
            },
            error: function() {
                $searchField.css("opacity", 1), console.log("There was an error performing the search.");
            }
        })) : alert("Please enter a search term.");
    }));
}(jQuery, window, document);